import { FC, useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';

export const InterwillIndirectAssetWarning: FC = () => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    ref.current?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <Container ref={ref}>
      <Icon name="warning-circle" />

      <span>
        <span style={{ fontWeight: 600 }}>This asset has an Indirect ownership type.</span> <br />{' '}
        If you continue and click “Add Asset”, the asset will be saved in your asset list in the
        app, but it will not be included in the Will, as only assets with Direct ownership can be
        assigned.
      </span>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  padding: 12px;
  gap: 12px;

  background-color: ${COLORS.warningBackground};

  border-radius: 8px;
  border: 1px solid ${COLORS.warning};
`;
